<div
  style="
    display: flex;
    align-items: center;
    justify-content: center;
    height: 500px;
  "
>
  <div>Loading...</div>
</div>
